import type * as bootstrap from './bootstrap';
import { LazyBootModule, LazyAction } from 'owa-bundling-light';

const lazyModule: LazyBootModule<typeof bootstrap> = new LazyBootModule(
    () => import(/* webpackChunkName: "OobesBoot" */ './bootstrap'),
    { name: 'OobesBoot' }
);
export const lazyOobeootstrap: LazyAction<typeof bootstrap.oobeBoostrap, typeof lazyModule> =
    new LazyAction(lazyModule, m => m.oobeBoostrap);
